import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

const SvgBkj12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.2 10.62",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.bkj12_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "bkj12_svg__a",
    d: "M14 5.01c-.1-.2-3.1-4.2-6.9-4.2a4.48 4.48 0 0 0-2 .4l.7.8a5.07 5.07 0 0 1 1.3-.2c2.7 0 5.1 2.6 5.9 3.5a11.33 11.33 0 0 1-2.7 2.4l.6.8a14.78 14.78 0 0 0 3.1-2.9l.2-.3ZM7.1 8.81c-2.7 0-5.1-2.6-5.9-3.5a11.33 11.33 0 0 1 2.7-2.4l-.6-.8a14.78 14.78 0 0 0-3.1 2.9l-.2.3.2.3c.1.2 3.1 4.2 6.9 4.2a4.48 4.48 0 0 0 2-.4l-.7-.8a5.07 5.07 0 0 1-1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bkj12_svg__a",
    d: "M4.9 4.11a2.66 2.66 0 0 0-.3 1.2 2.48 2.48 0 0 0 2.5 2.5 2 2 0 0 0 .7-.1l-.8-.9a1.45 1.45 0 0 1-1.4-1.5v-.2ZM8.5 5.31a.37.37 0 0 1 .1.3l.7.9a2.38 2.38 0 0 0 .3-1.2 2.48 2.48 0 0 0-2.5-2.5 2 2 0 0 0-.7.1l.7.9a1.45 1.45 0 0 1 1.4 1.5ZM2.716.624 3.496 0l7.997 9.996-.78.624z"
  }));
};

const SvgBkj22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.2 9",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.bkj22_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "bkj22_svg__a",
    d: "M7.1 2a2.5 2.5 0 1 0 2.5 2.5A2.48 2.48 0 0 0 7.1 2Zm0 4a1.5 1.5 0 1 1 1.5-1.5A1.54 1.54 0 0 1 7.1 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bkj22_svg__a",
    d: "M14 4.2C13.9 4 10.9 0 7.1 0S.3 4 .2 4.2l-.2.3.2.3C.3 5 3.3 9 7.1 9s6.8-4 6.9-4.2l.2-.3ZM7.1 8C4.4 8 2 5.4 1.2 4.5 2 3.6 4.4 1 7.1 1s5.1 2.6 5.9 3.5C12.2 5.4 9.9 8 7.1 8Z"
  }));
};

const SvgDdgl2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.6 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12 2.9-.4-.9H4.5l-.5.9-2.8 5.6H3V14h10V8.5h1.8ZM7.2 3h1.6l1.5 4.5H5.7ZM2.8 7.5 5.1 3h1.1L4.6 7.5ZM12 13H4v-1h8Zm0-2H4V8.5h8Zm-.6-3.5L9.9 3H11l2.2 4.5Z",
    transform: "translate(-1.2 -2)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgDdjk3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: 'new 0 0 16 16'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14h-11c-.3 0-.5-.2-.5-.5v-11c0-.3.2-.5.5-.5h11c.3 0 .5.2.5.5v11c0 .3-.2.5-.5.5z",
    style: {
      fill: 'none',
      stroke: 'currentColor',
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M6.5 6.5h3v3h-3z"
  }));
};

const SvgDz112 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.dz112_svg__a{fill:currentColor}.dz112_svg__b{fill:none;stroke:currentColor;stroke-miterlimit:10}')), /*#__PURE__*/React.createElement("path", {
    className: "dz112_svg__a",
    d: "M13.4 6.6h-1.9V5.4h1.9a.58.58 0 0 1 .6.6.58.58 0 0 1-.6.6ZM5.5 5.4h3v1.2h-3zM2.5 5.4v1.2H.6A.65.65 0 0 1 0 6a.65.65 0 0 1 .6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dz112_svg__b",
    d: "M12 8.5v-5a.47.47 0 0 0-.5-.5h-3a.47.47 0 0 0-.5.5v5a.47.47 0 0 0 .5.5h3a.47.47 0 0 0 .5-.5ZM2 11V1a.47.47 0 0 1 .5-.5h3A.47.47 0 0 1 6 1v10a.47.47 0 0 1-.5.5h-3A.47.47 0 0 1 2 11Z"
  }));
};

const SvgDz122 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.dz122_svg__a{fill:currentColor}.dz122_svg__b{fill:none;stroke:currentColor;stroke-miterlimit:10}')), /*#__PURE__*/React.createElement("path", {
    className: "dz122_svg__a",
    d: "M6.6.6v1.9H5.4V.6A.65.65 0 0 1 6 0a.65.65 0 0 1 .6.6ZM5.4 5.5h1.2v3H5.4zM5.4 11.5h1.2v1.9a.58.58 0 0 1-.6.6.65.65 0 0 1-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dz122_svg__b",
    d: "M8.5 2h-5a.47.47 0 0 0-.5.5v3a.47.47 0 0 0 .5.5h5a.47.47 0 0 0 .5-.5v-3a.47.47 0 0 0-.5-.5ZM11 12H1a.47.47 0 0 1-.5-.5v-3A.47.47 0 0 1 1 8h10a.47.47 0 0 1 .5.5v3a.47.47 0 0 1-.5.5Z"
  }));
};

const SvgEdit12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.9 11.9",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.edit12_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "edit12_svg__a",
    d: "M9 3.9v7H1v-9h6v-1H0v11h10v-8H9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "edit12_svg__a",
    d: "M10.2 0h-.1L4.7 5.5l-.6.5.8.8.5-.6L10.9.8V.7l-.7-.7z"
  }));
};

const SvgGb12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.68 10.75",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M10.68.78 9.97.07l-4.6 4.6L.71 0 0 .71l4.67 4.66L0 10.04l.71.71 4.66-4.67 4.6 4.6.71-.71-4.6-4.6 4.6-4.59z"
  }));
};

const SvgGsct3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 2.1h6.1c1.3 0 2.3.3 3 .9.7.6 1.1 1.4 1.1 2.5 0 .8-.2 1.4-.6 2-.4.5-1 .9-1.7 1.1.9.2 1.6.5 2.1 1.1.5.6.8 1.3.8 2.2 0 1.3-.5 2.3-1.4 3-.8.5-1.9.8-3.3.8h-6V2.1zm1.6 1.3V8h4.1c.9 0 1.7-.2 2.2-.6.5-.4.8-1 .8-1.8s-.2-1.3-.7-1.7c-.5-.4-1.2-.6-2.2-.6H4.3zm0 5.9v5h4.3c.9 0 1.7-.2 2.3-.5.7-.4 1-1.1 1-2 0-.9-.3-1.5-.9-1.9-.5-.4-1.3-.6-2.4-.6H4.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgGsdz2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gsdz2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "gsdz2_svg__a",
    d: "M0 0h15v2H0zM0 8h15v2H0zM0 4h9v2H0z"
  }));
};

const SvgGsdzy2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gsdzy2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "gsdzy2_svg__a",
    d: "M0 0h15v2H0zM0 8h15v2H0zM6 4h9v2H6z"
  }));
};

const SvgGsdzz2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gsdzz2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "gsdzz2_svg__a",
    d: "M0 0h15v2H0zM0 8h15v2H0zM3 4h9v2H3z"
  }));
};

const SvgGsjt3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gsjt3_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 18 16",
    style: {
      enableBackground: 'new 0 0 18 16'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.gsjt3_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("g", {
    id: "gsjt3_svg__\\u56FE\\u5C42_8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gsjt3_svg__st0",
    d: "m4.6 3.8 1.6-1.6H3.9L2.6 3.5 1.5 4.6l1.1 1.1 1.5 1.5h2.3L4.6 5.4h11.9V3.8zM14 8.9h-2.3l1.7 1.7H1.5v1.6h11.9l-1.6 1.6h2.3l1.3-1.3 1.1-1.1-1.1-1.2z"
  })));
};

const SvgGsjz3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gsjz3_svg__\\u56FE\\u5C42_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 18 16",
    style: {
      enableBackground: 'new 0 0 18 16'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.gsjz3_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "gsjz3_svg__st0",
    d: "M1.5 3h15v2h-15zM1.5 11h15v2h-15zM4.5 7h9v2h-9z"
  }));
};

const SvgGsxhx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gsxhx3_svg__\\u56FE\\u5C42_5_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.gsxhx3_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "gsxhx3_svg__st0",
    d: "M8 13.3c1.6 0 2.8-.4 3.6-1.3.8-.8 1.2-2 1.2-3.6V2.1h-1.4v6.3c0 1.2-.3 2.1-.8 2.7-.6.6-1.5 1-2.7 1-1.2 0-2.1-.3-2.7-1-.5-.6-.8-1.5-.8-2.7V2.1H3.2v6.3c0 1.6.4 2.8 1.2 3.6.8.9 2 1.3 3.6 1.3zM2.5 14.4h11v1.5h-11z"
  }));
};

const SvgGsxj2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gsxj2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "gsxj2_svg__a",
    d: "M11 15h1v1h-1zM3 15h1v1H3zM13 15h1v1h-1zM9 15h1v1H9zM5 15h1v1H5zM7 15h1v1H7zM15 15h1v1h-1zM15 5h1v1h-1zM15 7h1v1h-1zM15 3h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gsxj2_svg__a",
    d: "M8 0 0 8v8h2v-1H1V8.4L8.4 1H15v1h1V0H8zM15 13h1v1h-1zM15 9h1v1h-1zM15 11h1v1h-1z"
  }));
};

const SvgGsxt2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.9 13.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M11.9 1.6V0H3.1v1.6h3.5l-3 10.6H0v1.6h8.8v-1.6H5.2L8.3 1.6h3.6z"
  }));
};

const SvgGsxt3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 2h-4v1.6h3.5l-3 10.6H2.1v1.6h8.8v-1.6H7.3l3.1-10.6H14V2h-3.1z"
  }));
};

const SvgGsxx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gsxx3_svg__\\u56FE\\u5C42_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 18 16",
    style: {
      enableBackground: 'new 0 0 18 16'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.gsxx3_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "gsxx3_svg__st0",
    d: "M1.5 12.2h15v1.6h-15zM7.5 2.2h3v1.6h-3zM1.5 2.2h3v1.6h-3zM13.5 2.2h3v1.6h-3zM8.2 7.2h1.7v1.6H8.2zM4.8 7.2h1.7v1.6H4.8zM14.8 7.2h1.7v1.6h-1.7zM11.5 7.2h1.7v1.6h-1.7zM1.5 7.2h1.7v1.6H1.5z"
  }));
};

const SvgGsydq3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gsydq3_svg__\\u56FE\\u5C42_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 18 16",
    style: {
      enableBackground: 'new 0 0 18 16'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.gsydq3_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "gsydq3_svg__st0",
    d: "M1.5 3h15v2h-15zM1.5 11h15v2h-15zM7.5 7h9v2h-9z"
  }));
};

const SvgGsyj2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gsyj2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "gsyj2_svg__a",
    d: "M9 15h1v1H9zM11 15h1v1h-1zM13 15h1v1h-1zM5 15h1v1H5zM3 15h1v1H3zM15 15h1v1h-1zM7 15h1v1H7zM15 9h1v1h-1zM15 13h1v1h-1zM15 3h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gsyj2_svg__a",
    d: "M8 0a8 8 0 0 0-8 8v8h2v-1H1V8a7 7 0 0 1 7-7h7v1h1V0ZM15 5h1v1h-1zM15 7h1v1h-1zM15 11h1v1h-1z"
  }));
};

const SvgGszdq3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gszdq3_svg__\\u56FE\\u5C42_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 18 16",
    style: {
      enableBackground: 'new 0 0 18 16'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.gszdq3_svg__st0{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "gszdq3_svg__st0",
    d: "M1.5 3h15v2h-15zM1.5 11h15v2h-15zM1.5 7h9v2h-9z"
  }));
};

const SvgGszj2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.gszj2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "gszj2_svg__a",
    d: "M0 0v16h2v-1H1V1h14v1h1V0H0zM9 15h1v1H9zM13 15h1v1h-1zM11 15h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gszj2_svg__a",
    d: "M3 15h1v1H3zM15 15h1v1h-1zM5 15h1v1H5zM7 15h1v1H7zM15 7h1v1h-1zM15 5h1v1h-1zM15 3h1v1h-1zM15 11h1v1h-1zM15 13h1v1h-1zM15 9h1v1h-1z"
  }));
};

const SvgGsztys2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 2.1H7.2l-4.7 11H4L5.3 10h5.5l1.2 3.1h1.5ZM5.7 9 8 3.5 10.3 9Z",
    transform: "translate(-2.5 -2.1)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgH1Active2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.41 15.5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.h1-active2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "h1-active2_svg__a",
    d: "M11.8 8.4H9.3V5.9a.6.6 0 0 0-1.2 0v2.5H5.6a.6.6 0 1 0 0 1.2h2.5v2.5a.6.6 0 1 0 1.2 0V9.6h2.5a.6.6 0 0 0 0-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h1-active2_svg__a",
    d: "M15.2 2.5H8.7a.55.55 0 0 1-.5-.3l-.3-.9a2.3 2.3 0 0 0-2-1.3H2.2A2.22 2.22 0 0 0 0 2.2v11.1a2.22 2.22 0 0 0 2.2 2.2h13a2.22 2.22 0 0 0 2.2-2.2V4.7a2.1 2.1 0 0 0-2.2-2.2Zm1.1 10.8h-.1a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1V2.2a1 1 0 0 1 1-1h3.7a1 1 0 0 1 .9.6L7.4 3a1.2 1.2 0 0 0 1 .7h6.9a1 1 0 0 1 1 1Z"
  }));
};

const SvgH2Active2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.58 18",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2 6.2a2.13 2.13 0 0 0-1.2-.7v-.7a2.3 2.3 0 0 0-2.3-2.1h-8L8.3.4C8.3.1 8 0 7.7 0H2.3A2.3 2.3 0 0 0 0 2.1v13.8a2.37 2.37 0 0 0 .9 1.7h.2a1.59 1.59 0 0 0 1.2.4h13.8a3.17 3.17 0 0 0 2.8-1.9l2.6-8.3a1.77 1.77 0 0 0-.3-1.6ZM1.5 2.1a.71.71 0 0 1 .8-.7h4.9l1.4 2.4c0 .3.3.4.6.4h8.5a.71.71 0 0 1 .8.7v.7H5.7a2.8 2.8 0 0 0-2.6 1.9l-1.5 4.7V2.1Zm15.9 13.7a1.64 1.64 0 0 1-1.2.8H2.3a.9.9 0 0 1-.5-.1c0-.1-.2-.3 0-.4l2.6-8.3A1.64 1.64 0 0 1 5.6 7h13.8c.2 0 .3 0 .3.1.3 0 .3.1.3.4Z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgH3Active2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.h3-active2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "h3-active2_svg__a",
    d: "M17.8 3 15.1.2c-.2-.1-.3-.2-.5-.2H2.1A2.05 2.05 0 0 0 0 2.1v13.8A2.05 2.05 0 0 0 2.1 18h13.8a2 2 0 0 0 2.1-2V3.5a.76.76 0 0 0-.2-.5Zm-5.7-1.6v3.7a.54.54 0 0 1-.5.5H6.3c-.2 0-.4-.3-.4-.5V1.4ZM4.8 16.6v-4.8a.79.79 0 0 1 .8-.8h6.7a.79.79 0 0 1 .8.8v4.8Zm11.8-.7a.68.68 0 0 1-.7.7h-1.4v-4.8a2.11 2.11 0 0 0-2.1-2.1H5.6a2.11 2.11 0 0 0-2.1 2.1v4.8H2.1a.68.68 0 0 1-.7-.7V2.1a.68.68 0 0 1 .7-.7v-.1h2.4v3.8a1.79 1.79 0 0 0 1.8 1.8h5.4a1.79 1.79 0 0 0 1.8-1.8V1.3h.7l2.4 2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h3-active2_svg__a",
    d: "M10.4 4.5a.68.68 0 0 0 .7-.7v-.7a.7.7 0 0 0-1.4 0v.7a.68.68 0 0 0 .7.7Z"
  }));
};

const SvgHyzx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 10.5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.hyzx2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "hyzx2_svg__a",
    d: "M5.5 7A3.54 3.54 0 0 0 9 3.5V0H5.5A3.54 3.54 0 0 0 2 3.5 3.54 3.54 0 0 0 5.5 7Zm0-6H8v2.5A2.5 2.5 0 1 1 5.5 1ZM5.5 7.5c-3 0-5.4 1.3-5.5 3h1c.2-1 2-2 4.5-2s4.3 1 4.5 2h1c-.1-1.7-2.5-3-5.5-3Z"
  }));
};

const SvgJs12 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6V4.5A2.48 2.48 0 0 0 9 2H7a2.61 2.61 0 0 0-2 1 2.46 2.46 0 0 0-.5 1.5.47.47 0 0 0 .5.5.47.47 0 0 0 .5-.5A1.54 1.54 0 0 1 7 3h2a1.54 1.54 0 0 1 1.5 1.5V6h-6A1.54 1.54 0 0 0 3 7.5v5A1.54 1.54 0 0 0 4.5 14h7a1.54 1.54 0 0 0 1.5-1.5v-5A1.54 1.54 0 0 0 11.5 6Zm.5 6.5a.47.47 0 0 1-.5.5h-7a.47.47 0 0 1-.5-.5v-5a.47.47 0 0 1 .5-.5h7a.47.47 0 0 1 .5.5Z",
    transform: "translate(-3 -2)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJs22 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6V4.5A2.48 2.48 0 0 0 9 2H7a2.48 2.48 0 0 0-2.5 2.5V6A1.54 1.54 0 0 0 3 7.5v5A1.54 1.54 0 0 0 4.5 14h7a1.54 1.54 0 0 0 1.5-1.5v-5A1.54 1.54 0 0 0 11.5 6Zm-6-1.5A1.54 1.54 0 0 1 7 3h2a1.54 1.54 0 0 1 1.5 1.5V6h-5Zm6.5 8a.47.47 0 0 1-.5.5h-7a.47.47 0 0 1-.5-.5v-5a.47.47 0 0 1 .5-.5h7a.47.47 0 0 1 .5.5Z",
    transform: "translate(-3 -2)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0112 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M12 6 6 0v5.5H0v1h6V12l6-6z"
  }));
};

const SvgJt0122 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M6 5.5V0L0 6l6 6V6.5h6v-1H6z"
  }));
};

const SvgJt0212 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 12.4",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 8 7.5 1.8v5.7H2v1h5.5v5.7ZM8.5 4.2 12.3 8l-3.8 3.8Z",
    transform: "translate(-2 -1.8)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0222 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 12.4",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m2 8 6.2 6.2V8.5h5.5v-1H8.2V1.8Zm5.2 3.8L3.4 8l3.8-3.8Z",
    transform: "translate(-2 -1.8)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0312 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M12 6 5 0l2.8 5.5H0v1h7.8L5 12l7-6z"
  }));
};

const SvgJt0322 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "m0 6 7 6-2.8-5.5H12v-1H4.2L7 0 0 6z"
  }));
};

const SvgJt0412 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 5a2.92 2.92 0 0 0-2.9 2.5H2v1h6.1A3 3 0 0 0 14 8a3 3 0 0 0-3-3Z",
    transform: "translate(-2 -5)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0422 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.9 7.5A2.92 2.92 0 0 0 5 5a3 3 0 0 0-3 3 3 3 0 0 0 3 3 2.92 2.92 0 0 0 2.9-2.5H14v-1Z",
    transform: "translate(-2 -5)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0512 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 5a2.92 2.92 0 0 0-2.9 2.5H2v1h6.1A3 3 0 0 0 14 8a3 3 0 0 0-3-3Zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z",
    transform: "translate(-2 -5)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0522 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5 11a2.92 2.92 0 0 0 2.9-2.5H14v-1H7.9A2.92 2.92 0 0 0 5 5a3 3 0 0 0-3 3 3 3 0 0 0 3 3Zm0-5a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z",
    transform: "translate(-2 -5)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgJt0612 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.2 12.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "m5.9 0-.8.8 5.2 5.1H0v1h10.3L5.1 12l.8.8 6.3-6.4L5.9 0z"
  }));
};

const SvgJt0622 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.2 12.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "m6.3 12.8.8-.8-5.2-5.1h10.3v-1H1.9L7.1.8 6.3 0 0 6.4l6.3 6.4z"
  }));
};

const SvgJt0712 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M12 5.5H6.5V0h-1v5.5H0v1h5.5V12h1V6.5H12v-1z"
  }));
};

const SvgJt0812 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M11 0v5.5H0v1h11V12h1V0h-1z"
  }));
};

const SvgJt0822 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M1 12V6.5h11v-1H1V0H0v12h1z"
  }));
};

const SvgJt0912 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M11 0v5.8L4.9 0l-.8.7 5.2 4.8H0v1h9.3l-5.2 4.8.8.7L11 6.2V12h1V0h-1z"
  }));
};

const SvgJt0922 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M1 12V6.2L7.1 12l.8-.7-5.2-4.8H12v-1H2.7L7.9.7 7.1 0 1 5.8V0H0v12h1z"
  }));
};

const SvgJt2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 11.6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.jt2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "jt2_svg__a",
    d: "M3.1 1.6 4.7 0H2.4L1.1 1.3 0 2.4l1.1 1.1L2.6 5h2.3L3.1 3.2H15V1.6H3.1zM12.5 6.7h-2.3l1.7 1.7H0V10h11.9l-1.6 1.6h2.3l1.3-1.3L15 9.2 13.9 8l-1.4-1.3z"
  }));
};

const SvgJtzx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M0 0h12v1H0z"
  }));
};

const SvgJux3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 4v10h16V4H0zm14.8 8.8H1.2V5.2h13.6v7.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgLbgb2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M5.3 0 0 4.2l.6.8 4.7-3.8L10 5l.6-.8L5.3 0z"
  }));
};

const SvgLbzk2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 5",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M10 0 5.3 3.8.6 0 0 .8 5.3 5 10.6.8 10 0z"
  }));
};

const SvgLockClose2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.1 16.6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 7.5V5.2a4.12 4.12 0 0 0-4.1-4.1H7.4a4 4 0 0 0-4.1 4.1v2.4a1.79 1.79 0 0 0-1.8 1.8v6.5a1.79 1.79 0 0 0 1.8 1.8h9.5a1.79 1.79 0 0 0 1.8-1.8V9.3a2 2 0 0 0-1.9-1.8ZM4.5 5.2a3 3 0 0 1 3-3h1.2a3 3 0 0 1 3 3v2.4H4.5Zm8.9 10.6h-.1a.65.65 0 0 1-.6.6H3.3a.65.65 0 0 1-.6-.6V9.3a.65.65 0 0 1 .6-.6h9.5a.65.65 0 0 1 .6.6Z",
    transform: "translate(-1.5 -1.1)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgLockOpen2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.1 17.2",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 7.5v-3A4.12 4.12 0 0 0 8.7.4H7.4a4.12 4.12 0 0 0-4.1 4.1.65.65 0 0 0 .6.6.65.65 0 0 0 .6-.6 3 3 0 0 1 3-3h1.2a3 3 0 0 1 3 3v3H3.3a1.79 1.79 0 0 0-1.8 1.8v6.5a1.79 1.79 0 0 0 1.8 1.8h9.5a1.79 1.79 0 0 0 1.8-1.8V9.3a1.79 1.79 0 0 0-1.8-1.8Zm.6 8.3a.65.65 0 0 1-.6.6H3.3a.65.65 0 0 1-.6-.6V9.3a.65.65 0 0 1 .6-.6h9.5a.65.65 0 0 1 .6.6Z",
    transform: "translate(-1.5 -.4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgLpzx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12.14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5h-1.7c.1-.2.2-.5.3-.7a1.88 1.88 0 0 0-.3-1.5c-.7-.7-2-.5-2.9.5a1.38 1.38 0 0 0-.4.3c-.1-.1-.1-.2-.2-.2a3.32 3.32 0 0 0-1.4-1 1.88 1.88 0 0 0-1.5.3 1.35 1.35 0 0 0-.4 1.4 1.61 1.61 0 0 0 .3.9H2v4h2V14h8V8.5h2v-4ZM7.5 13H5V8.5h2.5Zm0-6.9v1.4H3v-2h4.5Zm0-1.8v.2H6a1.59 1.59 0 0 1-.5-1c0-.3 0-.5.1-.5a.37.37 0 0 1 .3-.1h.3a2.1 2.1 0 0 1 .8.6 3 3 0 0 1 .5.7Zm1-.1a3 3 0 0 1 .5-.7 1.73 1.73 0 0 1 1.2-.6c.1 0 .3 0 .3.1a.75.75 0 0 1 .1.5 2.66 2.66 0 0 1-.6 1H8.5ZM11 13H8.5V8.5H11Zm2-5.5H8.5v-2H13Z",
    transform: "translate(-2 -1.86)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgPeople2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 8a4 4 0 0 0 2.83-6.83A4 4 0 1 0 7 8Zm7 4.43A6.94 6.94 0 0 0 10.54 8a5.07 5.07 0 0 1-6.83 0C2 8.92.23 10.76 0 12.43a.52.52 0 0 0 .1.38.6.6 0 0 0 .38.19h13a.53.53 0 0 0 .48-.57Z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgQrCode2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.qr-code2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "qr-code2_svg__a",
    d: "M0 5h5V0H0Zm1-4h3v3H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qr-code2_svg__a",
    d: "M2 2h1v1H2zM6 0v5h5V0Zm4 4H7V1h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qr-code2_svg__a",
    d: "M8 2h1v1H8zM0 11h5V6H0Zm1-4h3v3H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qr-code2_svg__a",
    d: "M2 8h1v1H2zM10 7H9V6H6v5h1V8h1v1h3V6h-1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qr-code2_svg__a",
    d: "M8 10h1v1H8zM10 10h1v1h-1z"
  }));
};

const SvgSjbd2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 14",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.sjbd2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("circle", {
    className: "sjbd2_svg__a",
    cx: 4.5,
    cy: 12,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "sjbd2_svg__a",
    d: "M7.9 0H1.1A1.11 1.11 0 0 0 0 1.1v11.8A1.11 1.11 0 0 0 1.1 14h6.8A1.11 1.11 0 0 0 9 12.9V1.1A1.11 1.11 0 0 0 7.9 0Zm0 13H1.1c-.1 0-.1 0-.1-.1V11h7Zm.1-3H1V3h7Zm0-8H1l.1-1h6.8C8 1 8 1 8 1.1Z"
  }));
};

const SvgTudl2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.tudl2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "tudl2_svg__a",
    d: "M6 9H1V1h5v2h1V0H0v10h7V7H6v2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tudl2_svg__a",
    d: "M12 5 9 2.5v1.8H4v1.5h5v1.7L12 5z"
  }));
};

const SvgVip2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.2 14.3",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 1.5H3.8L.4 6 8 15.8 15.6 6Zm-.6 1 2.3 3h-2.7l-1.5-3Zm-4.4 0h1.4l1.5 3H5.8Zm-3 0h1.9l-1.5 3H2ZM2 6.5h2.6l2 5.9Zm3.7 0h4.6L8 13.4Zm3.7 5.9 2-5.9H14Z",
    transform: "translate(-.4 -1.5)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgWjgl2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 5H8.7L7 3.3 6.7 3H2v10h12V5Zm0 7H3V4h3.3L8 5.7l.3.3H13Z",
    transform: "translate(-2 -3)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXhx2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 13.8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xhx2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xhx2_svg__a",
    d: "M5.5 11.2a4.55 4.55 0 0 0 3.6-1.3 4.89 4.89 0 0 0 1.2-3.6V0H8.9v6.3A4.14 4.14 0 0 1 8.1 9a3.7 3.7 0 0 1-2.7 1 3.34 3.34 0 0 1-2.7-1 4.14 4.14 0 0 1-.8-2.7V0H.7v6.3a4.89 4.89 0 0 0 1.2 3.6 4.55 4.55 0 0 0 3.6 1.3ZM0 12.3h11v1.5H0z"
  }));
};

const SvgXtkj2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 11.6",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xtkj2_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xtkj2_svg__a",
    d: "M0 10h15v1.6H0zM6.7 0h1.7v1.6H6.7zM3.3 0H5v1.6H3.3zM13.3 0H15v1.6h-1.7zM10 0h1.7v1.6H10zM0 0h1.7v1.6H0zM0 6.7h1.6v1.7H0zM0 3.3h1.6V5H0zM13.4 6.7H15v1.7h-1.6zM13.4 3.3H15V5h-1.6z"
  }));
};

const SvgXx012 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M57.5 0H0v1h120V0H57.5z"
  }));
};

const SvgXx022 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xx022_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xx022_svg__a",
    d: "M0 0h9v1H0zM13 0h9v1h-9zM26 0h9v1h-9zM39 0h9v1h-9zM52 0h9v1h-9zM65 0h9v1h-9zM78 0h9v1h-9zM91 0h9v1h-9zM104 0h9v1h-9zM117 0h9v1h-9z"
  }));
};

const SvgXx032 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xx032_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xx032_svg__a",
    d: "M0 0h3v1H0zM4 0h3v1H4zM8 0h3v1H8zM12 0h3v1h-3zM16 0h3v1h-3zM20 0h3v1h-3zM24 0h3v1h-3zM28 0h3v1h-3zM32 0h3v1h-3zM36 0h3v1h-3zM40 0h3v1h-3zM44 0h3v1h-3zM48 0h3v1h-3zM52 0h3v1h-3zM56 0h3v1h-3zM60 0h3v1h-3zM64 0h3v1h-3zM68 0h3v1h-3zM72 0h3v1h-3zM76 0h3v1h-3zM80 0h3v1h-3zM84 0h3v1h-3zM88 0h3v1h-3zM92 0h3v1h-3zM96 0h3v1h-3zM100 0h3v1h-3zM104 0h3v1h-3zM108 0h3v1h-3zM112 0h3v1h-3zM116 0h3v1h-3z"
  }));
};

const SvgXx042 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xx042_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xx042_svg__a",
    d: "M0 0h1v1H0zM2 0h1v1H2zM4 0h1v1H4zM6 0h1v1H6zM8 0h1v1H8zM10 0h1v1h-1zM12 0h1v1h-1zM14 0h1v1h-1zM16 0h1v1h-1zM18 0h1v1h-1zM20 0h1v1h-1zM22 0h1v1h-1zM24 0h1v1h-1zM26 0h1v1h-1zM28 0h1v1h-1zM30 0h1v1h-1zM32 0h1v1h-1zM34 0h1v1h-1zM36 0h1v1h-1zM38 0h1v1h-1zM40 0h1v1h-1zM42 0h1v1h-1zM44 0h1v1h-1zM46 0h1v1h-1zM48 0h1v1h-1zM50 0h1v1h-1zM52 0h1v1h-1zM54 0h1v1h-1zM56 0h1v1h-1zM58 0h1v1h-1zM60 0h1v1h-1zM62 0h1v1h-1zM64 0h1v1h-1zM66 0h1v1h-1zM68 0h1v1h-1zM70 0h1v1h-1zM72 0h1v1h-1zM74 0h1v1h-1zM76 0h1v1h-1zM78 0h1v1h-1zM80 0h1v1h-1zM82 0h1v1h-1zM84 0h1v1h-1zM86 0h1v1h-1zM88 0h1v1h-1zM90 0h1v1h-1zM92 0h1v1h-1zM94 0h1v1h-1zM96 0h1v1h-1zM98 0h1v1h-1zM100 0h1v1h-1zM102 0h1v1h-1zM104 0h1v1h-1zM106 0h1v1h-1zM108 0h1v1h-1zM110 0h1v1h-1zM112 0h1v1h-1zM114 0h1v1h-1zM116 0h1v1h-1zM118 0h1v1h-1z"
  }));
};

const SvgXx052 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xx052_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xx052_svg__a",
    d: "M0 0h9v1H0zM13 0h2v1h-2zM19 0h9v1h-9zM32 0h2v1h-2zM38 0h9v1h-9zM51 0h2v1h-2zM57 0h9v1h-9zM70 0h2v1h-2zM76 0h9v1h-9zM89 0h2v1h-2zM95 0h9v1h-9zM108 0h2v1h-2zM114 0h9v1h-9z"
  }));
};

const SvgXx062 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121 1",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xx062_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xx062_svg__a",
    d: "M0 0h9v1H0zM13 0h2v1h-2zM19 0h2v1h-2zM25 0h9v1h-9zM38 0h2v1h-2zM44 0h2v1h-2zM50 0h9v1h-9zM63 0h2v1h-2zM69 0h2v1h-2zM75 0h9v1h-9zM88 0h2v1h-2zM94 0h2v1h-2zM100 0h9v1h-9zM113 0h2v1h-2zM119 0h2v1h-2z"
  }));
};

const SvgXzjx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 4v10h16V4Zm14.8 8.8H1.2V5.2h13.6Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzku3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xzku3_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.xzku3_svg__st2{fill:none}.xzku3_svg__st4{fill:currentColor}'), /*#__PURE__*/React.createElement("path", {
    className: "xzku3_svg__st2",
    d: "M11.4 4.7c-.6.7-1.9 1.1-3.4 1.1 1.5 0 2.8-.4 3.4-1.1zM4.2 5.9C3.5 5.4 3 4.7 3 4c0 .8.5 1.4 1.2 1.9zM11.8 5.9C10.9 6.6 9.5 7 8 7c1.5 0 2.9-.4 3.8-1.1.7-.5 1.2-1.1 1.2-1.9 0 .8-.5 1.4-1.2 1.9zM8 15.8c-2.1 0-3.8-.8-3.8-1.8 0 1 1.7 1.9 3.8 1.8 2.1.1 3.8-.7 3.8-1.7V14c0 1-1.7 1.8-3.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xzku3_svg__st2",
    d: "M4.2 5.9V14c0 1 1.7 1.8 3.8 1.8s3.8-.8 3.8-1.8V6c-.9.6-2.3 1-3.8 1s-2.9-.4-3.8-1.1zM8 5.8c1.5 0 2.8-.4 3.4-1.1.2-.2.3-.5.4-.7 0-1-1.7-1.8-3.8-1.8S4.2 3 4.2 4 5.9 5.8 8 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 4.1c0 .2-.2.4-.4.6.2-.2.4-.4.4-.6z",
    style: {
      fill: 'currentColor'
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "xzku3_svg__st4",
    d: "M11.8 6v8.1c0 1-1.7 1.8-3.8 1.8S4.2 15 4.2 14V5.9C3.5 5.4 3 4.8 3 4v10c0 1.7 2.2 3 5 3s5-1.3 5-3V4c0 .8-.5 1.4-1.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xzku3_svg__st4",
    d: "M4.2 5.9C5.1 6.6 6.5 7 8 7s2.9-.4 3.8-1.1C12.5 5.4 13 4.8 13 4c0-1.7-2.2-3-5-3S3 2.4 3 4c0 .7.5 1.4 1.2 1.9zM8 2.2c2.1 0 3.8.8 3.8 1.8 0 .2-.2.4-.4.6-.6.8-1.9 1.2-3.4 1.2C5.9 5.8 4.2 5 4.2 4S5.9 2.2 8 2.2z"
  }));
};

const SvgXzlbx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M2.6 2.5h10.8v12.9H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 2.4H4.2L.4 9l3.8 6.6h7.6L15.6 9l-3.8-6.6zm-.7 12H4.9L1.8 9l3.1-5.4h6.2L14.2 9l-3.1 5.4z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzljx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.2 13.2",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8 2.4H4.2L.4 9l3.8 6.6h7.6L15.6 9Zm-.7 12H4.9L1.8 9l3.1-5.4h6.2L14.2 9Z",
    transform: "translate(-.4 -2.4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzlx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8 4 0 9l8 5 8-5ZM1.9 9 8 5.2 14.1 9 8 12.8Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzlx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M2.6 2.5h10.8v12.9H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9 8 4 0 9l8 5 8-5zM1.9 9 8 5.2 14.1 9 8 12.8 1.9 9z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzpxsb = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.9 4 0 14h13.1L16 4Zm9.3 8.8H1.6l2.2-7.6h10.6Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzpxsbx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M2.6 2.5h10.8v12.9H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9 4 0 14h13.1L16 4H2.9zm9.3 8.8H1.6l2.2-7.6h10.6l-2.2 7.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzty3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M2.6 2.5h10.8v12.9H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4C3.6 4 0 6.3 0 9s3.6 5 8 5 8-2.2 8-5-3.6-5-8-5zm0 8.8c-3.8 0-6.8-1.7-6.8-3.8s3-3.8 6.8-3.8 6.8 1.7 6.8 3.8-3 3.8-6.8 3.8z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXztyjx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 4H5a5 5 0 0 0-5 5 5 5 0 0 0 5 5h6a5 5 0 0 0 5-5 5 5 0 0 0-5-5Zm0 8.8H5a3.8 3.8 0 0 1 0-7.6h6a3.8 3.8 0 1 1 0 7.6Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXztyx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8 4C3.6 4 0 6.3 0 9s3.6 5 8 5 8-2.2 8-5-3.6-5-8-5Zm0 8.8c-3.8 0-6.8-1.7-6.8-3.8s3-3.8 6.8-3.8 6.8 1.7 6.8 3.8-3 3.8-6.8 3.8Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzwd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10.04",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 4v7.6c.2 1.3 1.6 2.7 4.4 2.4 1.3-.3 1.9-.8 3.6-2.4 1.7-1.3 2.3-1.4 3.5-1.4a7.05 7.05 0 0 1 4.5 1.4V4Zm14.8 5.5a6.33 6.33 0 0 0-3.3-.7A6.08 6.08 0 0 0 8 10.2a13.31 13.31 0 0 1-3.6 2.4 3.2 3.2 0 0 1-3.2-1V5.2h13.6Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzwj3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M2.6 2.5h10.8v12.9H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4v7.6c.2 1.3 1.6 2.7 4.4 2.4 1.3-.3 1.9-.8 3.6-2.4 1.7-1.3 2.3-1.4 3.5-1.4.6 0 2.4-.1 4.5 1.4V4H0zm14.8 5.5c-1.6-.7-2.1-.7-3.3-.7-1.6.2-2.3.5-3.5 1.4-1 .8-2.5 2.1-3.6 2.4-1.3.2-2.3 0-3.2-1V5.2h13.6v4.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzxj3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xzxj3_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", null, '.xzxj3_svg__st0{fill:none}'), /*#__PURE__*/React.createElement("path", {
    className: "xzxj3_svg__st0",
    d: "M2.6 2.5h10.8v12.9H2.6z",
    id: "xzxj3_svg__\\u900F\\u660E\\u5C42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xzxj3_svg__st0",
    d: "M2.2 4h11.6v10H2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 4H2.2L0 6.2v5.6L2.2 14h11.6l2.2-2.2V6.2L13.8 4zm1 7.3-1.5 1.5H2.6l-1.4-1.5V6.6l1.4-1.4h10.7l1.5 1.5v4.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzxjjx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8 4H2.2L0 6.2v5.6L2.2 14h11.6l2.2-2.2V6.2Zm1 7.3-1.5 1.5H2.6l-1.4-1.5V6.6l1.4-1.4h10.7l1.5 1.5Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzybx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 4H5C2.2 4 0 6.2 0 9s2.2 5 5 5h6c2.8 0 5-2.2 5-5s-2.2-5-5-5zm0 8.8H5c-2.1 0-3.8-1.7-3.8-3.8S2.9 5.2 5 5.2h6c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzyj3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 4H3.2C1.4 4 0 5.4 0 7.2v3.6C0 12.6 1.4 14 3.2 14h9.6c1.8 0 3.2-1.4 3.2-3.2V7.2C16 5.4 14.6 4 12.8 4zm2 6.8c0 1.1-.9 2-2 2H3.2c-1.1 0-2-.9-2-2V7.2c0-1.1.9-2 2-2h9.6c1.1 0 2 .9 2 2v3.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzyjjx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 4H3.2A3.16 3.16 0 0 0 0 7.2v3.6A3.16 3.16 0 0 0 3.2 14h9.6a3.16 3.16 0 0 0 3.2-3.2V7.2A3.16 3.16 0 0 0 12.8 4Zm2 6.8a2 2 0 0 1-2 2H3.2a2 2 0 0 1-2-2V7.2a2 2 0 0 1 2-2h9.6a2 2 0 0 1 2 2Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzyx = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5A6.5 6.5 0 1 0 14.5 9 6.49 6.49 0 0 0 8 2.5Zm0 11.8A5.3 5.3 0 0 1 8 3.7a5.3 5.3 0 0 1 0 10.6Z",
    transform: "translate(-1.5 -2.5)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzyx3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M2.6 2.5h10.8v12.9H2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5C4.4 2.5 1.5 5.4 1.5 9s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5S11.6 2.5 8 2.5zm0 11.8c-2.9 0-5.3-2.4-5.3-5.3S5.1 3.7 8 3.7 13.3 6 13.3 9s-2.4 5.3-5.3 5.3z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzzlc = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 4v10h16V4Zm3 8.8H1.2V5.2H3Zm8.8 0H4.2V5.2h7.6Zm3 0H13V5.2h1.8Z",
    transform: "translate(0 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzzlc3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18",
    style: {
      enableBackground: 'new 0 0 16 18'
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 4v10h16V4H0zm1.2 8.8V5.2H3v7.6H1.2zm3 0V5.2h7.6v7.6H4.2zm10.6 0H13V5.2h1.8v7.6z",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgXzzt = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.xzzt_svg__a{fill:currentColor}')), /*#__PURE__*/React.createElement("path", {
    className: "xzzt_svg__a",
    d: "M8.8 5v8.1c0 1-1.7 1.8-3.8 1.8S1.2 14 1.2 13V4.9A2.38 2.38 0 0 1 0 3v10c0 1.7 2.2 3 5 3s5-1.3 5-3V3a2.7 2.7 0 0 1-1.2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "xzzt_svg__a",
    d: "M1.2 4.9A6.34 6.34 0 0 0 5 6a6.34 6.34 0 0 0 3.8-1.1A2.38 2.38 0 0 0 10 3c0-1.7-2.2-3-5-3S0 1.4 0 3a2.53 2.53 0 0 0 1.2 1.9ZM5 1.2c2.1 0 3.8.8 3.8 1.8 0 .2-.2.4-.4.6A4.25 4.25 0 0 1 5 4.8C2.9 4.8 1.2 4 1.2 3S2.9 1.2 5 1.2Z"
  }));
};

const SvgYjbd2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 8",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 4v8h12V4Zm10 1L9.2 7.3l-.8.7-.4.3-.4-.3-.8-.7L4 5Zm-9 .5L6 8l-3 2.5ZM4 11l2.8-2.4 1.2 1 1.2-1L12 11Zm9-.5L10 8l3-2.5Z",
    transform: "translate(-2 -4)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgYuanjiao112 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M8 0 0 8v8h1V8.4L8.4 1H16V0H8z"
  }));
};

const SvgYuanjiao122 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 0a8 8 0 0 0-8 8v8h1V8a7 7 0 0 1 7-7h8V0Z",
    transform: "translate(-1)",
    style: {
      fill: 'currentColor'
    }
  }));
};

const SvgYuanjiao132 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: 'currentColor'
    },
    d: "M9 0H0v16h1V1h15V0H9z"
  }));
};

const SvgYuanjiao142 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 0a2 2 0 0 0-2 2 1.69 1.69 0 0 0 .3 1L4 12.3a1.69 1.69 0 0 0-1-.3 2 2 0 1 0 2 2 1.69 1.69 0 0 0-.3-1L14 3.7a1.69 1.69 0 0 0 1 .3 2 2 0 0 0 0-4ZM3 15a1 1 0 0 1 0-2 1 1 0 0 1 0 2ZM15 3a.94.94 0 0 1-1-1 1 1 0 0 1 2 0 .94.94 0 0 1-1 1Z",
    transform: "translate(-1)",
    style: {
      fill: 'currentColor'
    }
  }));
};

export { SvgBkj12 as Bkj12, SvgBkj22 as Bkj22, SvgDdgl2 as Ddgl2, SvgDdjk3 as Ddjk3, SvgDz112 as Dz112, SvgDz122 as Dz122, SvgEdit12 as Edit12, SvgGb12 as Gb12, SvgGsct3 as Gsct3, SvgGsdz2 as Gsdz2, SvgGsdzy2 as Gsdzy2, SvgGsdzz2 as Gsdzz2, SvgGsjt3 as Gsjt3, SvgGsjz3 as Gsjz3, SvgGsxhx3 as Gsxhx3, SvgGsxj2 as Gsxj2, SvgGsxt2 as Gsxt2, SvgGsxt3 as Gsxt3, SvgGsxx3 as Gsxx3, SvgGsydq3 as Gsydq3, SvgGsyj2 as Gsyj2, SvgGszdq3 as Gszdq3, SvgGszj2 as Gszj2, SvgGsztys2 as Gsztys2, SvgH1Active2 as H1Active2, SvgH2Active2 as H2Active2, SvgH3Active2 as H3Active2, SvgHyzx2 as Hyzx2, SvgJs12 as Js12, SvgJs22 as Js22, SvgJt0112 as Jt0112, SvgJt0122 as Jt0122, SvgJt0212 as Jt0212, SvgJt0222 as Jt0222, SvgJt0312 as Jt0312, SvgJt0322 as Jt0322, SvgJt0412 as Jt0412, SvgJt0422 as Jt0422, SvgJt0512 as Jt0512, SvgJt0522 as Jt0522, SvgJt0612 as Jt0612, SvgJt0622 as Jt0622, SvgJt0712 as Jt0712, SvgJt0812 as Jt0812, SvgJt0822 as Jt0822, SvgJt0912 as Jt0912, SvgJt0922 as Jt0922, SvgJt2 as Jt2, SvgJtzx2 as Jtzx2, SvgJux3 as Jux3, SvgLbgb2 as Lbgb2, SvgLbzk2 as Lbzk2, SvgLockClose2 as LockClose2, SvgLockOpen2 as LockOpen2, SvgLpzx2 as Lpzx2, SvgPeople2 as People2, SvgQrCode2 as QrCode2, SvgSjbd2 as Sjbd2, SvgTudl2 as Tudl2, SvgVip2 as Vip2, SvgWjgl2 as Wjgl2, SvgXhx2 as Xhx2, SvgXtkj2 as Xtkj2, SvgXx012 as Xx012, SvgXx022 as Xx022, SvgXx032 as Xx032, SvgXx042 as Xx042, SvgXx052 as Xx052, SvgXx062 as Xx062, SvgXzjx as Xzjx, SvgXzku3 as Xzku3, SvgXzlbx3 as Xzlbx3, SvgXzljx as Xzljx, SvgXzlx as Xzlx, SvgXzlx3 as Xzlx3, SvgXzpxsb as Xzpxsb, SvgXzpxsbx3 as Xzpxsbx3, SvgXzty3 as Xzty3, SvgXztyjx as Xztyjx, SvgXztyx as Xztyx, SvgXzwd as Xzwd, SvgXzwj3 as Xzwj3, SvgXzxj3 as Xzxj3, SvgXzxjjx as Xzxjjx, SvgXzybx3 as Xzybx3, SvgXzyj3 as Xzyj3, SvgXzyjjx as Xzyjjx, SvgXzyx as Xzyx, SvgXzyx3 as Xzyx3, SvgXzzlc as Xzzlc, SvgXzzlc3 as Xzzlc3, SvgXzzt as Xzzt, SvgYjbd2 as Yjbd2, SvgYuanjiao112 as Yuanjiao112, SvgYuanjiao122 as Yuanjiao122, SvgYuanjiao132 as Yuanjiao132, SvgYuanjiao142 as Yuanjiao142 };
